import React from "react";
import useStyles from "../styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import {TableCell, TableRow} from "@material-ui/core";

const Signs = ({selectedMonth, selectedWorkDays, months}) => {
    const classes = useStyles();

    return (selectedMonth && selectedWorkDays && months && <div className={classes.annotations}>
        <Table className={classes.annotationsTableDesktop}>
            <TableBody>
                <TableRow>
                    <TableCell className={classes.dayCellLock}/>
                    <TableCell className={classes.tableCellBorderNone}>- вільних годин немає</TableCell>

                    <TableCell className={classes.dayCell}/>
                    <TableCell className={classes.tableCellBorderNone}>- є вільні години</TableCell>

                    <TableCell className={classes.dayCellActive}/>
                    <TableCell className={classes.tableCellBorderNone}>- вибраний час</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        <Table className={classes.annotationsTableMobile}>
            <TableBody>
                <TableRow>
                    <TableCell className={classes.dayCellLock}/>
                    <TableCell className={classes.tableCellBorderNone}>- вільних годин немає</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className={classes.dayCell}/>
                    <TableCell className={classes.tableCellBorderNone}>- є вільні години</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className={classes.dayCellActive}/>
                    <TableCell className={classes.tableCellBorderNone}>- вибраний час</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </div>);
};

export default Signs;
